// extracted by mini-css-extract-plugin
export default {"page_size_selector":"PageSizeSelector_page_size_selector__WDojQ","active":"PageSizeSelector_active__MpQna"};